import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs/Observable'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from 'containers/PartnerOptions/constants'
import { addToast } from 'containers/Toasts/actions'

import {
  DISABLE_INTEGRATION_REQUEST_ASYNC as DISABLE_GSUITE_INTEGRATION,
  ENABLE_INTEGRATION_REQUEST_ASYNC as ENABLE_GSUITE_INTEGRATION,
} from './Gsuite/constants'
import { DISABLE_365_INTEGRATION_REQUEST_ASYNC as DISABLE_O365_INTEGRATION } from './O365/constants'
import {
  delExchangeInfoError,
  delExchangeInfoSuccess,
  disableMailboxError,
  disableMailboxSuccess,
  getExchangeInfoError,
  getExchangeInfoSuccess,
  getMailboxInfoError,
  getMailboxInfoSuccess,
  updExchangeInfoError,
  updExchangeInfoSuccess,
  updMailboxError,
  updMailboxSuccess,
} from './actions'
import {
  DELETE_SERVER_SIDE_ASYNC,
  DISABLE_MAILBOX_ASYNC,
  MAILBOX_REQUEST_ASYNC,
  SERVER_SIDE_REQUEST_ASYNC,
  UPDATE_MAILBOX_ASYNC,
  UPDATE_SERVER_SIDE_ASYNC,
} from './constants'

const getExchangeInfoEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      SERVER_SIDE_REQUEST_ASYNC.INITIATE,
      UPDATE_SERVER_SIDE_ASYNC.SUCCESS,
      DELETE_SERVER_SIDE_ASYNC.SUCCESS,
      DISABLE_MAILBOX_ASYNC.SUCCESS,
      ENABLE_GSUITE_INTEGRATION.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.emailServer)
      return true
    })
    .mergeMap(() =>
      api.settings
        .getEmailServerSettings(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getExchangeInfoSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getExchangeInfoError, error)))
        .takeUntil(action$.ofType(SERVER_SIDE_REQUEST_ASYNC.CANCEL))
    )

const updExchangeInfoEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_SERVER_SIDE_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .updEmailServerSettings(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().form.ExchangeForm.values
      )
      .map((response) => updExchangeInfoSuccess(response))
      .catch((error) =>
        Observable.of(
          epicsErrorHandler(updExchangeInfoError, error),
          addToast({ message: error?.response?.message || error?.response, type: 'error' })
        )
      )
      .takeUntil(action$.ofType(UPDATE_SERVER_SIDE_ASYNC.CANCEL))
  )

const delExchangeInfoEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(DELETE_SERVER_SIDE_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .delExchangeCred(store.getState().partnerOptions.selectedCompany?.value)
      .map((response) => delExchangeInfoSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(delExchangeInfoError, error)))
      .takeUntil(action$.ofType(DELETE_SERVER_SIDE_ASYNC.CANCEL))
  )

const getMailboxInfoEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      MAILBOX_REQUEST_ASYNC.INITIATE,
      DELETE_SERVER_SIDE_ASYNC.SUCCESS,
      UPDATE_MAILBOX_ASYNC.SUCCESS
    )
    .filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.settings.emailServer)
      return true
    })
    .mergeMap(() =>
      api.dashboard
        .getHeartbeat(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => getMailboxInfoSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(getMailboxInfoError, error)))
        .takeUntil(action$.ofType(MAILBOX_REQUEST_ASYNC.CANCEL))
    )

const updMailboxEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$.ofType(UPDATE_MAILBOX_ASYNC.INITIATE).mergeMap(() =>
    api.settings
      .updMailboxInfo(
        store.getState().partnerOptions.selectedCompany?.value,
        store.getState().settings.emailServer.self.mailboxData['911']
      )
      .map((response) => updMailboxSuccess(response))
      .catch((error) => Observable.of(epicsErrorHandler(updMailboxError, error)))
      .takeUntil(action$.ofType(MAILBOX_REQUEST_ASYNC.CANCEL))
  )

const disableMailboxEpic = (action$, store, { api, epicsErrorHandler }) =>
  action$
    .ofType(
      DISABLE_MAILBOX_ASYNC.INITIATE,
      DISABLE_GSUITE_INTEGRATION.SUCCESS,
      DISABLE_O365_INTEGRATION.SUCCESS
    )
    .mergeMap(() =>
      api.settings
        .disable911Mailbox(store.getState().partnerOptions.selectedCompany?.value)
        .map((response) => disableMailboxSuccess(response))
        .catch((error) => Observable.of(epicsErrorHandler(disableMailboxError, error)))
        .takeUntil(action$.ofType(DISABLE_MAILBOX_ASYNC.CANCEL))
    )

export default combineEpics(
  getExchangeInfoEpic,
  updExchangeInfoEpic,
  getMailboxInfoEpic,
  delExchangeInfoEpic,
  updMailboxEpic,
  disableMailboxEpic
)
